// modules
import { createSelector } from 'reselect'
import { get } from 'lodash'

// utils
import { patientSelector } from 'src/store/modules/patient/selectors'

export const patientActivityLog$ = createSelector(
  patientSelector,
  (patient = {}) => get(patient, ['activityLog'], {})
)

export const patientActivityLogs$ = createSelector(
  patientActivityLog$,
  ({ logs = [] }) => logs
)

export const predefinedActivityLogFilters$ = createSelector(
  patientActivityLog$,
  ({ predefinedActivityLogFilters = {} }) => predefinedActivityLogFilters
)
